import { API } from './axiosInstance'
import {CLIENT_ID, CLIENT_SECRET} from "../constants";

export const getStores = () =>
  API.get(`/shops?client_id=${CLIENT_ID}&client_secret=${CLIENT_SECRET}`).then(res => res.data)